import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm$order$items, _vm$gettingParentCont;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "--one-column"
  }, [_c("div", {
    staticClass: "order-maincontent-data-value bold withBeforeSeparator"
  }, [_c("div", {
    staticClass: "flex justify-start"
  }, [_c("div", {
    staticClass: "flex --inline-flex cursor--pointer flex-grow--no",
    on: {
      click: function click($event) {
        _vm.detailsVisibility = !_vm.detailsVisibility;
      }
    }
  }, [_vm.isContainerOrderBeforeMerge ? [_vm._v(" Pending container order, with " + _vm._s(_vm.order.containerNbSubOrders) + " suborder(s) ")] : _vm.isContainerOrder ? [_vm._v(" Container order, with " + _vm._s(_vm.order.containerNbSubOrders) + " suborder(s) ")] : _vm.isLinkedToContainerOrder ? [_vm._v(" On container #" + _vm._s(_vm.order.parentContainerOrder.reference_order.shorterReference()) + " ")] : [_vm._v("Link to a pending container order")], _c(VIcon, {
    class: ["ml-2", "fas", _vm.detailsVisibility ? "fa-angle-double-up" : "fa-angle-double-down"],
    attrs: {
      size: "0.85rem"
    }
  })], 2)]), !_vm.detailsVisibility ? [_vm.isLinkedToContainerOrder ? _c("div", {
    staticClass: "text-smaller text-normal mt-2"
  }, [_vm.isLinkedToContainerOrderBeforeMerge ? [_vm.order.isSubcontainerPutInbound ? _c("div", [_vm._v(' Put inbound. Will create a pre-arrival warehouse stock when the container status will be updated to "In delivery" (not reserved) ')]) : _c("div", [_vm._v(' Direct delivery. Will immediately create an OC delivery with all products when the container status will be updated to "In delivery" ')])] : [_vm.order.isSubcontainerPutInbound ? _c("div", [_vm._v(' Put inbound. Has created a pre-arrival warehouse stock when the container status has been updated to "In delivery" ')]) : _c("div", [_vm._v(' Has been immediately transformed in an OC delivery with all products when the container status has been updated to "In delivery" ')])]], 2) : _vm._e()] : _vm._e()], 2), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.detailsVisibility,
      expression: "detailsVisibility"
    }],
    staticClass: "order-maincontent-data"
  }, [_vm.isContainerOrder ? [_c("div", {
    staticClass: "order-maincontent-data-value --one-column mt-3"
  }, [_vm.isContainerOrderDeliveredWithAnySuborderBeforeDelivery ? _c("div", {
    staticClass: "flex mb-2"
  }, [_c(VAlert, {
    staticClass: "--small",
    attrs: {
      dense: "",
      outlined: "",
      type: "warning",
      color: "orange",
      text: ""
    }
  }, [_vm._v(" Reminder : You should schedule the delivery of the suborders ")])], 1) : _vm._e(), _c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
    attrs: {
      headers: _vm.isContainerOrderBeforeMerge ? _vm.beforeMergeTableHeaders : _vm.afterMergeTableHeaders,
      items: _vm.order.containerSubOrders,
      "items-per-page": -1,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.reference",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "ml-1"
        }, [_c("router-link", {
          staticClass: "router-link",
          attrs: {
            to: _vm.orderDetails(item.id_order)
          }
        }, [_vm._v(" " + _vm._s(item.reference_order.shorterReference()) + " ")])], 1), _c("div", [_c("span", {
          class: ["badge line-height-1_1", _vm.getSuborderStatusClass(item.status)]
        }, [_vm._v(" " + _vm._s(_vm.getOrderStatusLabel(item.status)) + " ")])])];
      }
    }, {
      key: "item.user",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c("div", {
          domProps: {
            innerHTML: _vm._s(String.parseForVHtml(_vm.getFullNameUserHtml(item.user, true, true)))
          }
        })];
      }
    }, {
      key: "item.deliveryAddress",
      fn: function fn(_ref3) {
        var _item$delivery_addres;
        var item = _ref3.item;
        return [item.isSubcontainerPutInbound ? _c("div", {
          staticClass: "text-italic"
        }, [_vm._v("Put Inbound")]) : [_c("div", {
          staticClass: "text-smaller text-italic text-underline"
        }, [_vm._v("Direct delivery")]), _c("div", [_vm._v(" " + _vm._s("".concat(item.delivery_address.city, ", ").concat(item.delivery_address.country.iso_code).concat((_item$delivery_addres = item.delivery_address.state) !== null && _item$delivery_addres !== void 0 && _item$delivery_addres.iso_state ? "-" + item.delivery_address.state.iso_state : "")) + " ")])]];
      }
    }, {
      key: "item.postingMonth",
      fn: function fn(_ref4) {
        var _item$pricePostingUsa;
        var item = _ref4.item;
        return [((_item$pricePostingUsa = item.pricePostingUsaPro) === null || _item$pricePostingUsa === void 0 ? void 0 : _item$pricePostingUsa.id) > 0 ? _c("div", [_vm._v(" " + _vm._s(_vm._f("formatDate_stringMonth")(item.pricePostingUsaPro.applicationDate)) + " ")]) : _c("div", [_vm._v("-")])];
      }
    }, {
      key: "item.amount",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm.formatPrice(item.total_amount_currency)) + " " + _vm._s(_vm.getSymbolCurrency(item.currency)) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", {
          staticClass: "table-actions"
        }, [!_vm.isAnyActionInProgress ? _c("span", {
          on: {
            click: function click($event) {
              return _vm.confirmUnlinkOrder(item.id_order);
            }
          }
        }, [_vm._v(" Unlink ")]) : _vm._e()])])];
      }
    }], null, true)
  }), _c("div", {
    staticClass: "flex justify-between items-start"
  }, [_c("div", {
    staticClass: "mt-2"
  }, [_vm.isContainerOrderBeforeMerge ? _c(VBtn, {
    staticClass: "dfwa-btn highlight --small",
    attrs: {
      rounded: "",
      loading: _vm.isExportingXlsFreight
    },
    on: {
      click: function click($event) {
        return _vm.exportXlsFreight();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-file-excel mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" FullOrder XLS Freight ")], 1) : _vm._e()], 1), _c("div", {
    staticClass: "text-smaller mt-1"
  }, [_c("div", {
    staticClass: "flex justify-end"
  }, [_c("div", [_vm._v("Suborders Nb Bottles :")]), _c("div", {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.order.containerSubOrdersQuantity))])]), _c("div", {
    staticClass: "flex justify-end"
  }, [_c("div", [_vm._v("Suborders Total :")]), _c("div", {
    staticClass: "text-bold"
  }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.order.containerSubOrdersTotalAmountCurrency)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")])]), _vm.isContainerOrderBeforeMerge && ((_vm$order$items = _vm.order.items) === null || _vm$order$items === void 0 ? void 0 : _vm$order$items.length) > 0 ? [_c("div", {
    staticClass: "flex justify-end mt-4"
  }, [_c("div", [_vm._v("Global Nb Bottles :")]), _c("div", {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.order.containerGlobalQuantity))])]), _c("div", {
    staticClass: "flex justify-end"
  }, [!_vm.order.isFullyCalculatedAmounts ? _c("div", {
    staticClass: "text-italic"
  }, [_vm._v(" Amounts recalculation needed ")]) : [_c("div", [_vm._v("Global Total :")]), _c("div", {
    staticClass: "text-bold"
  }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.order.containerGlobalTotalAmountCurrency)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")])]], 2)] : _vm._e()], 2)])], 1), _vm.isContainerOrderBeforeMerge ? _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.gettingCompatibleOrders.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.gettingCompatibleOrders.form, "valid", $$v);
      },
      expression: "gettingCompatibleOrders.form.valid"
    }
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("Link a new suborder")]), _c("div", [_c(VAutocomplete, {
    attrs: {
      disabled: _vm.gettingCompatibleOrders.isPending || _vm.isAnyActionInProgress,
      items: _vm.gettingCompatibleOrders.result,
      "item-value": "id_order",
      "item-text": "displayLabel",
      label: !_vm.gettingCompatibleOrders.isPending ? "Orders compatible" : "Loading...",
      "no-data-text": "No compatible existing orders, on the same departure warehouse",
      "hide-details": "true",
      "hide-selected": "",
      filter: _vm.filterVAutocomplete,
      rules: [_vm.formRules.mustSelectValue]
    },
    model: {
      value: _vm.gettingCompatibleOrders.form.orderId,
      callback: function callback($$v) {
        _vm.$set(_vm.gettingCompatibleOrders.form, "orderId", $$v);
      },
      expression: "gettingCompatibleOrders.form.orderId"
    }
  })], 1), _c(VAlert, {
    staticClass: "--small",
    attrs: {
      dense: "",
      outlined: "",
      type: "info",
      color: "blue",
      text: ""
    }
  }, [_vm._v(" Orders with : same warehouse departure, same country of arrival, sea freight, not invoiced, not shipped, not deliver as available stocks, professional customer ")]), _c(VBtn, {
    staticClass: "dfwa-btn highlight --small mt-3",
    attrs: {
      rounded: "",
      loading: _vm.linkingOrder.isPending,
      disabled: _vm.isAnyActionInProgress || !_vm.gettingCompatibleOrders.form.valid
    },
    on: {
      click: _vm.confirmLinkOrderOnCompatibleOrder
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-link mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Link to container ")], 1)], 1)], 1) : _vm._e()] : _vm.isLinkedToContainerOrder ? [((_vm$gettingParentCont = _vm.gettingParentContainer.result) === null || _vm$gettingParentCont === void 0 ? void 0 : _vm$gettingParentCont.id_order) > 0 ? [_c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_c("div", [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      rounded: "",
      to: _vm.orderDetails(_vm.gettingParentContainer.result.id_order)
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-link mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Open container order ")], 1)], 1)]), _c("div", [_c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_c("div", {
    staticClass: "title-small"
  }, [_vm._v("Customer")]), _c("div", {
    domProps: {
      innerHTML: _vm._s(String.parseForVHtml(_vm.getFullNameUserHtml(_vm.gettingParentContainer.result.user)))
    }
  })]), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_c("div", {
    staticClass: "title-small"
  }, [_vm._v("Container status")]), _c("div", [_c("span", {
    class: ["badge line-height-1_1", _vm.gettingParentContainer.result.status === _vm.orderStatus.find(function (x) {
      return x.id === "CANCELLED";
    }).status ? "danger" : "success"]
  }, [_vm._v(" " + _vm._s(_vm.orderStatus.filter(function (os) {
    return os.status === _vm.gettingParentContainer.result.status;
  })[0].value) + " ")])]), _c("div", [_vm._v(_vm._s(_vm.gettingParentContainer.result.containerNbSubOrders) + " included order(s)")]), _c("div", [_vm._v(" Total : " + _vm._s("".concat(_vm.formatPrice(_vm.isLinkedToContainerOrderBeforeMerge ? _vm.gettingParentContainer.result.containerGlobalTotalAmountCurrency : _vm.gettingParentContainer.result.total_amount_currency), " ").concat(_vm.getSymbolCurrency(_vm.gettingParentContainer.result.currency))) + " ")])])])] : _vm._e(), _vm.isLinkedToContainerOrderBeforeMerge ? _c("div", {
    staticClass: "grid-cols-x1"
  }, [_c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_c("div", {
    staticClass: "title-small"
  }, [_vm._v(' Action when container status will be updated to "In delivery" ')]), _c("div", {
    staticClass: "display-switch"
  }, [_c("span", {
    class: _vm.order.isSubcontainerPutInbound ? "" : "text-bold"
  }, [_vm._v(" Direct delivery. Will immediately create an OC delivery with all products ")]), _c(VSwitch, {
    staticClass: "mt-0",
    attrs: {
      disabled: _vm.updatingSubcontainerInbound.isPending,
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.confirmUpdateSubcontainerInbound();
      }
    },
    model: {
      value: _vm.order.isSubcontainerPutInbound,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "isSubcontainerPutInbound", $$v);
      },
      expression: "order.isSubcontainerPutInbound"
    }
  }), _c("span", {
    class: !_vm.order.isSubcontainerPutInbound ? "" : "text-bold"
  }, [_vm._v(" Put inbound. Will create a pre-arrival warehouse stock ")])], 1)]), _c("div", {
    staticClass: "flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn secondary --small",
    attrs: {
      rounded: "",
      loading: _vm.unlinkingContainer.isPending,
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.confirmUnlinkOrder(_vm.order.id_order);
      }
    }
  }, [_vm._v(" Unlink order ")])], 1)]) : _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_vm.order.isSubcontainerPutInbound ? _c("div", [_vm._v(' Put inbound. Has created a pre-arrival stock when the container status has been updated to "In delivery" ')]) : _c("div", [_vm._v(' Has been immediately transformed in an OC delivery with all products when the container status has been updated to "In delivery" ')])])] : [_c("div", [_c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.gettingCompatibleContainers.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.gettingCompatibleContainers.form, "valid", $$v);
      },
      expression: "gettingCompatibleContainers.form.valid"
    }
  }, [_c("div", {
    staticClass: "title-small"
  }, [_vm._v("Container order")]), _c("div", [_c(VAutocomplete, {
    staticClass: "v-text-field-no-label required",
    attrs: {
      placeholder: "Container order",
      items: _vm.gettingCompatibleContainers.result,
      "item-value": "id_order",
      "item-text": "displayLabel",
      "no-data-text": "No compatible container order available",
      "hide-details": "auto",
      disabled: _vm.gettingCompatibleContainers.isPending,
      rules: [_vm.formRules.mustSelectValue],
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.gettingCompatibleContainers.form.containerOrderId,
      callback: function callback($$v) {
        _vm.$set(_vm.gettingCompatibleContainers.form, "containerOrderId", $$v);
      },
      expression: "gettingCompatibleContainers.form.containerOrderId"
    }
  })], 1), _c(VBtn, {
    staticClass: "dfwa-btn highlight --small mt-3",
    attrs: {
      rounded: "",
      loading: _vm.linkingOrder.isPending,
      disabled: _vm.isAnyActionInProgress || !_vm.gettingCompatibleContainers.form.valid
    },
    on: {
      click: _vm.confirmLinkOrderOnCompatibleContainer
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-link mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Link to container ")], 1)], 1)], 1)])]], 2), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };